import { Suspense, lazy } from 'react'
import { Route, Routes } from 'react-router-dom'
import LazyLoader from '../components/LazyLoader/LazyLoader'
import ErrorBoundary from '../components/ErrorBoundary/ErrorBoundary'
import '../styles/Global.style.css'
import ScreenGuard from '../components/ScreenGuard.js'
import NotFoundPage from '../pages/NotFoundPage/NotFoundPage.js'
import RoleBasedRedirect from '../components/RoleBasedRedirect.js'
import { CenterFilterProvider } from '../context/CenterFilterContext.js'

// SALES ROUTES
const CustomerForm = lazy(() => import('../pages/Customer/Customer'))
const SalesRepForm = lazy(() => import('../pages/SalesRep/SalesRepForm'))
const EnquiryForm = lazy(() => import('../pages/Enquiry/EnquiryForm'))
// const AmendmentForm = lazy(() => import('../pages/Amendments/Amendments'))
// const AmendmentTable = lazy(() => import('../pages/Amendments/Reports/AmendmentsTable'))
const Agency = lazy(() => import('../pages/Agency/Agency'))
const AgencyRep = lazy(() => import('../pages/AgencyRep/AgencyRep'))
const CustomerReports = lazy(() => import('../pages/Customer/reports/CustomerReports'))
const CustomerGroupCompany = lazy(() => import('../pages/CutomerGroupCompany/CustomerGroupCompany'))
const EnquiryReports = lazy(() => import('../pages/Enquiry/reports/EnquiryReports'))
const SiteVisits = lazy(() => import('../pages/SiteVisits/SiteVisits'))

// LEGAL ROUTES
// const Contract = lazy(() => import('../pages/Legal/Contract/ContractForm'))
// const ContractTable = lazy(() => import('../pages/Legal/Contract/reports/ContractTable'))

// OPERATIONS ROUTES
const MeetingRoomBooking = lazy(
  () => import('../pages/Operations/MeetingRoomBooking/MeetingRoomBooking.js')
)
const Parking = lazy(() => import('../pages/Operations/Parking/Parking'))
const DayPass = lazy(() => import('../pages/Operations/DayPass/DayPass'))
const RecordOt = lazy(() => import('../pages/Operations/RecordOT/RecordOT'))
const AdditionalCharges = lazy(
  () => import('../pages/Operations/AdditionalCharges/AdditionalCharges')
)
const RecordStationaries = lazy(
  () => import('../pages/Operations/RecordStationaries/RecordStationaries')
)
const Ims = lazy(() => import('../pages/Operations/IMS/IMS'))
const ExitCheckList = lazy(() => import('../pages/Operations/ExitChecklist/ExitCheckList'))
const DeliveryChallan = lazy(() => import('../pages/Operations/DeliveryChallan/DeliveryChallan'))
// const Onboarding = lazy(() => import('../pages/Operations/Onboardings/Onboardings'))
// const OnboardingReports = lazy(
//   () => import('../pages/Operations/Onboardings/reports/OnboardingTable')
// )
const RCLSubmission = lazy(() => import('../pages/RCL/RCLSubmission'))
// const CenterForm = lazy(() => import('../pages/Center/CenterForm'))
const CenterForm = lazy(() => import('../pages/Center/Center.js'))
const OrganisationForm = lazy(() => import('../pages/Organisation/Organisation'))
const RclForm = lazy(() => import('../pages/Rclform/Rclform'))

// FACILITIES ROUTES

const ProductForm = lazy(() => import('../pages/ProductManagementForm/ProductForm'))
const ProductType = lazy(() => import('../pages/ProductType/ProductTypeForm'))
const MaintenanceScheduleForm = lazy(
  () => import('../pages/MaintenanceScheduleForm/MaintenanceScheduleForm')
)
const MaintenanceRecord = lazy(() => import('../pages/MaintenanceRecord/MaintenanceRecordForm'))
const InvoiceSchedular = lazy(() => import('../pages/InvoiceSchedular/InvoiceSchedular'))
// HR ROUTES
const Employee = lazy(() => import('../pages/HR/EmployeeDetails/EmployeeForm'))
const EmployeeDetails = lazy(() => import('../pages/HR/EmployeeDetails/reports/EmployeeDetails'))
const EmployeeExitCheckList = lazy(
  () => import('../pages/HR/EmployeeExitCheckList/EmployeeExitCheckList')
)
const EmployeeExitCheckListReports = lazy(
  () => import('../pages/HR/EmployeeExitCheckList/Reports/EmployeeExitReport')
)
// const Leavemanagement = lazy(() => import('../pages/HR/LeaveManagement/LeaveManagement'))
const Profile = lazy(() => import('../pages/Auth/Profile/Profile.js'))
const LeaveManagementV2 = lazy(
  () => import('../pages/HR/LeaveManagementv2.js/LeaveManagementv2.js')
)

// DASHBOARD ROUTES
const SalesDashboard = lazy(() => import('../pages/Dashboards/SalesDashboard/SalesDashboard'))
const LegalDashboard = lazy(() => import('../pages/Dashboards/LegalDashboard/LegalDashboard'))
const OperationsDashboard = lazy(
  () => import('../pages/Dashboards/OperationsDashboard/OperationsDashboard')
)
const ProjectsDashboard = lazy(
  () => import('../pages/Dashboards/ProjectsDashboard/ProjectsDashboard')
)
const HrDashboard = lazy(() => import('../pages/Dashboards/HrDashboard/HrDashboard'))

const UpdatePage = lazy(() => import('../pages/UpdatePage/UpdatePage.js'))
const RegisterPage = lazy(() => import('../pages/Auth/Register/Register.js'))
const MeetingRoom = lazy(() => import('../pages/Operations/MeetingRoom/MeetingRoom.js'))

const MeetingRoomCredits = lazy(
  () => import('../pages/Accounts/meetingRoomCredits/MeetingRoomCredits.js')
)
const ClientInvoices = lazy(() => import('../pages/Accounts/ClientInvoice/ClientInvoiceReports.js'))
const PurchaseContract = lazy(
  () => import('../pages/facilities/PurchaseContract/PurchaseContract.js')
)
const PurchaseContractRecord = lazy(
  () => import('../pages/facilities/PurchaseContract/PurchaseContractRecord.js')
)
const PurchaseContractSchedule = lazy(
  () => import('../pages/facilities/PurchaseContractSchedule/PurchaseContractSchedule.js')
)
const PurchaseContractScheduleReport = lazy(
  () => import('../pages/facilities/PurchaseContractSchedule/PurchaseContractScheduleReport.js')
)
const PurchaseContractScheduleEdit = lazy(
  () =>
    import('../pages/facilities/PurchaseContractSchedule/components/PurchaseContractScheduleEditV2/PurchaseContractScheduleEdit.js')
)
const Product = lazy(() => import('../pages/facilities/Product/Product.js'))
const Vendors = lazy(() => import('../pages/VendorsForm/Vendors.js'))
const InvoiceSchedule = lazy(() => import('../pages/Accounts/InvoiceSchedule/InvoiceSchedule.js'))
const InvoiceScheduleReports = lazy(
  () => import('../pages/Accounts/InvoiceSchedule/InvoiceScheduleReports.js')
)
const InvoiceScheduleEdit = lazy(
  () => import('../pages/Accounts/InvoiceSchedule/InvoiceScheduleEdit.js')
)

const ContractInvoices = lazy(() => import('../pages/Accounts/ClientInvoice/ContractInvoices.js'))
const VendorType = lazy(() => import('../pages/Auth/VendorType/VendorType.js'))
const Units = lazy(() => import('../pages/Auth/Units/Units.js'))
const ClientAttendance = lazy(
  () => import('../pages/Operations/ClientAttendance/ClientAttendance.js')
)

const ProjectCosting = lazy(() => import('../pages/facilities/ProjectCosting/ProjectCosting.js'))
const ProjectCostingReport = lazy(
  () => import('../pages/facilities/ProjectCosting/ProjectCostingReport.js')
)
const ProjectCostingEdit = lazy(
  () => import('../pages/facilities/ProjectCosting/ProjectCostingEdit.js')
)

const CheckListCreate = lazy(() => import('../pages/Accounts/checklist/ChecklistCreate.js'))
const CheckListReports = lazy(() => import('../pages/Accounts/checklist/ChecklistReport.js'))
const CheckListEdit = lazy(() => import('../pages/Accounts/checklist/ChecklistEdit.js'))

const WorkflowCreate = lazy(() => import('../pages/Operations/workflow/WorkflowCreate.js'))
const WorkflowReport = lazy(() => import('../pages/Operations/workflow/WorkflowReports.js'))
const WorkflowEdit = lazy(() => import('../pages/Operations/workflow/WorkflowEdit.js'))

const LeaseFinanceInstitution = lazy(
  () => import('../pages/Auth/LeaseFinanceInstitution/Institution.js')
)

const VisitorManagement = lazy(() => import('../pages/VisitorManagement/VisitorManagement.js'))
const VisitorManagementReport = lazy(
  () => import('../pages/VisitorManagement/VisitorManagementReports.js')
)
const VisitorManagementEdit = lazy(
  () => import('../pages/VisitorManagement/VisitorManagementEdit.js')
)
const WatchmanRegister = lazy(
  () => import('../pages/Operations/Watchman/WatchmanManagementPage.js')
)

const AmendmentCreate = lazy(() => import('../pages/Legal/Amendments/AmendmentCreate.js'))
const AmendmentReport = lazy(() => import('../pages/Legal/Amendments/AmendmentReport.js'))
const AmendmentEdit = lazy(() => import('../pages/Legal/Amendments/AmendmentEdit.js'))
const AmendmentDetailPage = lazy(() => import('../pages/Legal/Amendments/AmendmentDetailPage.js'))

const ContractCreateV2 = lazy(() => import('../pages/Legal/ContractV2/CreateContractPage.js'))
const ContractReportV2 = lazy(() => import('../pages/Legal/ContractV2/ContractReport.js'))
const ContractEditV2 = lazy(() => import('../pages/Legal/ContractV2/EditContractPage.js'))

const AdditionalServicesCreate = lazy(
  () => import('../pages/Operations/AdditionalServices/AdditionalServiceCreate.js')
)
const AdditionalServicesReport = lazy(
  () => import('../pages/Operations/AdditionalServices/AdditionalServiceReport.js')
)
const AdditionalServicesEdit = lazy(
  () => import('../pages/Operations/AdditionalServices/AdditionalServiceEdit.js')
)

const CreateOnboardingV2 = lazy(
  () => import('../pages/Operations/OnboardingV2/CreateOnboardingPage.js')
)

const OnboardingReportsV2 = lazy(
  () => import('../pages/Operations/OnboardingV2/OnboardingReport.js')
)
const EditOnboardingPage = lazy(
  () => import('../pages/Operations/OnboardingV2/EditOnboardingPage.js')
)
const NotificationPage = lazy(() => import('../pages/Auth/NotificationsPage/NotificationsPage.js'))
const WalkInPage = lazy(() => import('../pages/Operations/walkIn/WalkIn.js'))

export const ROUTES = {
  // SALES ROUTES
  ADD_CENTER: '/add-center',
  CREATE_FORM: '/create-form',
  CREATE_CUSTOMER: '/create-customer',
  CREATE_SALES_REP: '/create-sales-rep',
  CREATE_ENQUIRY: '/create-enquiry',
  CREATE_ORGANISATION: '/create-organisation',
  SITE_VISITS: '/site-visits',
  // CREATE_AMENDMENTS: '/create-amendments',
  // AMENDMENTS_REPORT: '/amendment-reports',
  CREATE_AGENCY: '/create-agency',
  CREATE_AGENCY_REP: '/create-agency-rep',
  CUSTOMER_REPORTS: '/customer-reports',
  CREATE_CUSTOMER_GROUP: '/create-customer-group',
  ENQUIRY_REPORTS: '/enquiry-reports',

  // LEGAL ROUTES
  CREATE_SALES_CONTRACT: '/create-sales-contract',
  SALES_CONTRACT_REPORTS: '/sales-contract-reports',
  // CONTRACT_CREATE_V2: '/create-contract-v2',
  // CONTRACT_REPORT_V2: '/contract-report-v2',
  CONTRACT_EDIT_V2: '/edit-contract/:contractId',

  // OPERATIONS ROUTES
  BOOK_MEETING_ROOM: '/book-meeting-room',
  CREATE_PARKING: '/create-parking',
  CREATE_DAY_PASS: '/create-day-pass',
  RECORD_OT: '/record-ot',
  ADDITIONAL_CHARGES: '/chargeable-customization',
  RECORD_STATIONARIES: '/record-stationaries',
  CREATE_IMS: '/create-ims',
  CREATE_EXIT_CHECKLIST: '/create-exit-checklist',
  CREATE_DELIVERY_CHALLAN: '/create-delivery-challan',
  RCL_SUBMISSION: '/checklist-response',
  CREATE_ONBOARDING: '/create-onboarding',
  ONBOARDING_REPORTS: '/resident-clients',
  // CREATE_ONBOARDING_V2: '/create-onboarding-v2',
  // ONBOARDING_REPORT_V2: '/onboarding-report-v2',
  EDIT_ONBOARDING_V2: '/edit-onboarding/:id',
  MEETING_ROOM: '/meeting-room',

  // FACILITIES ROUTES
  CREATE_VENDOR: '/create-vendor',
  CREATE_PRODUCT: '/create-equipments',
  CREATE_PRODUCT_TYPE: '/create-product-type',
  MAINTENANCE_SCHEDULE: '/maintenance-schedule',
  MAINTENANCE_RECORD: '/maintenance-record',
  INVOICE_SCHEDULAR: '/invoice-schedular',
  INVOICE_SCHEDULE: '/invoice-schedule',
  INVOICE_SCHEDULE_REPORT: '/invoice-schedule-report',

  // HR ROUTES
  CREATE_EMPLOYEE: '/create-employee',
  EMPLOYEE_DETAILS: '/employee-details',
  EMPLOYEE_EXIT_CHECKLIST: '/employee-exit-checklist',
  EMPLOYEE_EXIT_CHECKLIST_REPORTS: '/employee-exit-checklists-reports',
  // LEAVE_MANAGEMENT: '/leave-management',
  PROFILE: '/profile',
  LEAVE_MANAGEMENT_V2: '/leave-management-v2',

  // Dashboard Routes
  SALES_DASHBOARD: '/marketing-dashboard',
  LEGAL_DASHBOARD: '/sales-dashboard',
  OPERATIONS_DASHBOARD: '/operations-dashboard',
  PROJECTS_DASHBOARD: '/facility-dashboard',
  HR_DASHBOARD: '/hr-dashboard',

  UPDATE: '/update-user',
  REGISTER: '/register-user',
  CONTRACT_INVOICES: '/client-invoice/contract/:contractId/invoices',
  INVOICE_SCHEDULE_EDIT: '/invoice-schedule/contract/:contractId/invoices',
  // Add these new routes
  MEETING_ROOM_CREDITS: '/meeting-room-credits',
  CLIENT_INVOICES: '/client-invoices',
  VENDOR_PURCHASE_CONTRACT: '/purchase-contract',
  VENDOR_PURCHASE_CONTRACT_REPORTS: '/purchase-contract-reports',
  VENDOR_PURCHASE_CONTRACT_SCHEDULE: '/purchase-contract-schedule',
  VENDOR_PURCHASE_CONTRACT_SCHEDULE_REPORTS: '/purchase-contract-schedule-reports',
  VENDOR_PURCHASE_CONTRACT_SCHEDULE_EDIT: '/purchase-contract-schedule/:id',
  PRODUCT: '/product',
  VENDOR_TYPES: '/vendor-types',
  UNITS: '/units',
  USER_ATTENDANCE: '/client-attendance',

  PROJECT_COSTING: '/project-costing',
  PROJECT_COSTING_REPORTS: '/project-costing-reports',
  PROJECT_COSTING_EDIT: '/project-costing-edit/:id',

  CHECKLIST_CREATE: '/create-opex-checklist',
  CHECKLIST_REPORTS: '/opex-checklist-reports',
  CHECKLIST_EDIT: '/edit-opex-checklist/:id',

  WORKFLOW_CREATE: '/create-opex-workflow',
  WORKFLOW_REPORTS: '/opex-workflow-reports',
  WORKFLOW_EDIT: '/workflows/edit',
  LEASE_FINANCE_INSTITUTION: '/lease-finance-institution',

  VISITOR_MANAGEMENT: '/visitor-management',
  VISITOR_MANAGEMENT_REPORT: '/visitor-management-reports',
  VISITOR_MANAGEMENT_EDIT: '/visitor-management/:id',

  WATCHMAN_REGISTER: '/watchman-management',

  AMENDMENT_REPORT: '/amendment-report',
  AMENDMENT_CREATE: '/create-amendment',
  AMENDMENT_EDIT: '/amendments/:contractId',
  AMENDMENT_NEW: '/amendments/:contractId/new',
  AMENDMENT_DETAILS: '/amendments/:contractId/:amendmentId',

  ADDITIONAL_SERVICES_CREATE: '/create-additional-services',
  ADDITIONAL_SERVICES_REPORT: '/additional-services-report',
  ADDITIONAL_SERVICES_EDIT: '/Edit-additional-service/:id',

  WALK_IN: '/walk-in',
}

const ROUTE_SCREEN_ID_MAP = {
  [ROUTES.UPDATE]: 42,
  [ROUTES.ADD_CENTER]: 2,
  [ROUTES.CREATE_SALES_REP]: 3,
  [ROUTES.CREATE_ENQUIRY]: 4,
  [ROUTES.ENQUIRY_REPORTS]: 5,
  [ROUTES.CREATE_ORGANISATION]: 6,
  [ROUTES.SITE_VISITS]: 7,
  [ROUTES.CREATE_AGENCY]: 8,
  [ROUTES.CREATE_AGENCY_REP]: 9,
  [ROUTES.CREATE_CUSTOMER_GROUP]: 10,

  [ROUTES.CREATE_SALES_CONTRACT]: 11,
  [ROUTES.SALES_CONTRACT_REPORTS]: 12,
  // [ROUTES.CONTRACT_CREATE_V2]: 60,
  // [ROUTES.CONTRACT_REPORT_V2]: 60,
  [ROUTES.CONTRACT_EDIT_V2]: 12,
  [ROUTES.BOOK_MEETING_ROOM]: 13,
  [ROUTES.CREATE_PARKING]: 14,
  [ROUTES.CREATE_DAY_PASS]: 15,
  [ROUTES.RECORD_OT]: 16,
  [ROUTES.ADDITIONAL_CHARGES]: 17,
  [ROUTES.RECORD_STATIONARIES]: 18,
  [ROUTES.CREATE_IMS]: 19,
  [ROUTES.CREATE_EXIT_CHECKLIST]: 20,
  [ROUTES.CREATE_DELIVERY_CHALLAN]: 21,
  [ROUTES.CREATE_ONBOARDING]: 22,
  [ROUTES.ONBOARDING_REPORTS]: 23,
  [ROUTES.EDIT_ONBOARDING_V2]: 23,
  [ROUTES.INVOICE_SCHEDULE]: 24,
  [ROUTES.INVOICE_SCHEDULE_REPORT]: 25,
  [ROUTES.CREATE_VENDOR]: 26,
  [ROUTES.CREATE_PRODUCT]: 27,
  [ROUTES.CREATE_PRODUCT_TYPE]: 28,
  [ROUTES.MAINTENANCE_SCHEDULE]: 29,
  [ROUTES.MAINTENANCE_RECORD]: 30,
  [ROUTES.CREATE_EMPLOYEE]: 31,
  [ROUTES.EMPLOYEE_DETAILS]: 32,
  [ROUTES.EMPLOYEE_EXIT_CHECKLIST]: 33,
  [ROUTES.EMPLOYEE_EXIT_CHECKLIST_REPORTS]: 34,
  [ROUTES.LEAVE_MANAGEMENT_V2]: 35,
  [ROUTES.SALES_DASHBOARD]: 37,
  [ROUTES.LEGAL_DASHBOARD]: 38,
  [ROUTES.OPERATIONS_DASHBOARD]: 39,
  [ROUTES.PROJECTS_DASHBOARD]: 40,
  [ROUTES.HR_DASHBOARD]: 41,
  [ROUTES.REGISTER]: 1,
  [ROUTES.MEETING_ROOM]: 43,

  // Add new mappings
  [ROUTES.MEETING_ROOM_CREDITS]: 44,
  [ROUTES.CLIENT_INVOICES]: 45,
  [ROUTES.VENDOR_PURCHASE_CONTRACT]: 46,
  [ROUTES.VENDOR_PURCHASE_CONTRACT_REPORTS]: 47,
  [ROUTES.VENDOR_PURCHASE_CONTRACT_SCHEDULE]: 48,
  [ROUTES.VENDOR_PURCHASE_CONTRACT_SCHEDULE_REPORTS]: 49,
  [ROUTES.VENDOR_PURCHASE_CONTRACT_SCHEDULE_EDIT]: 49,
  [ROUTES.PRODUCT]: 50,

  // Edit pages use same ID as their reports page
  [ROUTES.CONTRACT_INVOICES]: 45, // Same as CLIENT_INVOICES
  [ROUTES.INVOICE_SCHEDULE_EDIT]: 25, // Same as INVOICE_SCHEDULE_REPORT
  [ROUTES.VENDOR_TYPES]: 51,
  [ROUTES.UNITS]: 52,
  [ROUTES.USER_ATTENDANCE]: 53,

  [ROUTES.PROJECT_COSTING]: 54,
  [ROUTES.PROJECT_COSTING_REPORTS]: 54,
  [ROUTES.PROJECT_COSTING_EDIT]: 54,

  [ROUTES.CHECKLIST_REPORTS]: 55,
  [ROUTES.CHECKLIST_EDIT]: 55,
  [ROUTES.CHECKLIST_CREATE]: 55,

  [ROUTES.WORKFLOW_CREATE]: 56,
  [ROUTES.WORKFLOW_REPORTS]: 56,
  [ROUTES.WORKFLOW_EDIT]: 56,

  [ROUTES.LEASE_FINANCE_INSTITUTION]: 57,

  [ROUTES.VISITOR_MANAGEMENT]: 58,
  [ROUTES.VISITOR_MANAGEMENT_REPORT]: 59,
  [ROUTES.VISITOR_MANAGEMENT_EDIT]: 59,

  [ROUTES.WATCHMAN_REGISTER]: 60,

  [ROUTES.AMENDMENT_CREATE]: 61,
  [ROUTES.AMENDMENT_REPORT]: 62,
  [ROUTES.AMENDMENT_EDIT]: 62,
  [ROUTES.AMENDMENT_NEW]: 62,
  [ROUTES.AMENDMENT_DETAILS]: 62,

  [ROUTES.ADDITIONAL_SERVICES_CREATE]: 63,
  [ROUTES.ADDITIONAL_SERVICES_REPORT]: 64,
  [ROUTES.ADDITIONAL_SERVICES_EDIT]: 64,

  [ROUTES.WALK_IN]: [13, 14, 15],
}

const AppRoutes = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<LazyLoader />}>
        <Routes>
          <Route path="/" element={<RoleBasedRedirect />} />
          <Route path="/notifications" element={<NotificationPage />} />
          {/* SALES ROUTES */}
          <Route
            path={ROUTES.ADD_CENTER}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.ADD_CENTER]}>
                <CenterForm />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CREATE_FORM}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_FORM]}>
                <RclForm />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CREATE_CUSTOMER}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_CUSTOMER]}>
                <CustomerForm />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CREATE_SALES_REP}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_SALES_REP]}>
                <SalesRepForm />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CREATE_ENQUIRY}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_ENQUIRY]}>
                <EnquiryForm />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CREATE_ORGANISATION}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_ORGANISATION]}>
                <OrganisationForm />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.SITE_VISITS}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.SITE_VISITS]}>
                <SiteVisits />
              </ScreenGuard>
            }
          />
          {/* <Route
            path={ROUTES.CREATE_AMENDMENTS}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_AMENDMENTS]}>
                <AmendmentForm />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.AMENDMENTS_REPORT}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.AMENDMENTS_REPORT]}>
                <AmendmentTable />
              </ScreenGuard>
            }
          /> */}
          <Route
            path={ROUTES.CREATE_AGENCY}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_AGENCY]}>
                <Agency />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CREATE_AGENCY_REP}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_AGENCY_REP]}>
                <AgencyRep />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CUSTOMER_REPORTS}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CUSTOMER_REPORTS]}>
                <CustomerReports />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CREATE_CUSTOMER_GROUP}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_CUSTOMER_GROUP]}>
                <CustomerGroupCompany />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.ENQUIRY_REPORTS}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.ENQUIRY_REPORTS]}>
                <EnquiryReports />
              </ScreenGuard>
            }
          />

          {/* LEGAL ROUTES */}
          <Route
            path={ROUTES.CREATE_SALES_CONTRACT}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_SALES_CONTRACT]}>
                <ContractCreateV2 />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.SALES_CONTRACT_REPORTS}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.SALES_CONTRACT_REPORTS]}>
                <ContractReportV2 />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CONTRACT_EDIT_V2}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CONTRACT_EDIT_V2]}>
                <ContractEditV2 />
              </ScreenGuard>
            }
          />

          {/* OPERATIONS ROUTES */}
          <Route
            path={ROUTES.BOOK_MEETING_ROOM}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.BOOK_MEETING_ROOM]}>
                <MeetingRoomBooking />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CREATE_PARKING}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_PARKING]}>
                <Parking />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CREATE_DAY_PASS}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_DAY_PASS]}>
                <DayPass />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.RECORD_OT}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.RECORD_OT]}>
                <RecordOt />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.ADDITIONAL_CHARGES}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.ADDITIONAL_CHARGES]}>
                <AdditionalCharges />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.RECORD_STATIONARIES}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.RECORD_STATIONARIES]}>
                <RecordStationaries />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CREATE_IMS}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_IMS]}>
                <Ims />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CREATE_EXIT_CHECKLIST}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_EXIT_CHECKLIST]}>
                <ExitCheckList />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CREATE_DELIVERY_CHALLAN}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_DELIVERY_CHALLAN]}>
                <DeliveryChallan />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.RCL_SUBMISSION}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.RCL_SUBMISSION]}>
                <RCLSubmission />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CREATE_ONBOARDING}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_ONBOARDING]}>
                <CreateOnboardingV2 />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.ONBOARDING_REPORTS}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.ONBOARDING_REPORTS]}>
                <OnboardingReportsV2 />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.EDIT_ONBOARDING_V2}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.EDIT_ONBOARDING_V2]}>
                <EditOnboardingPage />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.INVOICE_SCHEDULE}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.INVOICE_SCHEDULE]}>
                <InvoiceSchedule />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.INVOICE_SCHEDULE_REPORT}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.INVOICE_SCHEDULE_REPORT]}>
                <CenterFilterProvider>
                  <InvoiceScheduleReports />
                </CenterFilterProvider>
              </ScreenGuard>
            }
          />

          {/* FACILITIES ROUTES */}
          <Route
            path={ROUTES.CREATE_VENDOR}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_VENDOR]}>
                <Vendors />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CREATE_PRODUCT}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_PRODUCT]}>
                <ProductForm />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CREATE_PRODUCT_TYPE}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_PRODUCT_TYPE]}>
                <ProductType />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.MAINTENANCE_SCHEDULE}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.MAINTENANCE_SCHEDULE]}>
                <MaintenanceScheduleForm />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.MAINTENANCE_RECORD}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.MAINTENANCE_RECORD]}>
                <MaintenanceRecord />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.INVOICE_SCHEDULAR}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.INVOICE_SCHEDULAR]}>
                <InvoiceSchedular />
              </ScreenGuard>
            }
          />

          {/* HR ROUTES */}
          <Route
            path={ROUTES.CREATE_EMPLOYEE}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CREATE_EMPLOYEE]}>
                <Employee />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.EMPLOYEE_DETAILS}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.EMPLOYEE_DETAILS]}>
                <EmployeeDetails />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.EMPLOYEE_EXIT_CHECKLIST}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.EMPLOYEE_EXIT_CHECKLIST]}>
                <EmployeeExitCheckList />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.EMPLOYEE_EXIT_CHECKLIST_REPORTS}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.EMPLOYEE_EXIT_CHECKLIST_REPORTS]}>
                <EmployeeExitCheckListReports />
              </ScreenGuard>
            }
          />

          <Route
            path={ROUTES.LEAVE_MANAGEMENT_V2}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.LEAVE_MANAGEMENT_V2]}>
                <LeaveManagementV2 />
              </ScreenGuard>
            }
          />

          {/* Dashboard Routes */}
          <Route
            path={ROUTES.SALES_DASHBOARD}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.SALES_DASHBOARD]}>
                <SalesDashboard />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.LEGAL_DASHBOARD}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.LEGAL_DASHBOARD]}>
                <LegalDashboard />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.OPERATIONS_DASHBOARD}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.OPERATIONS_DASHBOARD]}>
                <OperationsDashboard />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.PROJECTS_DASHBOARD}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.PROJECTS_DASHBOARD]}>
                <ProjectsDashboard />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.HR_DASHBOARD}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.HR_DASHBOARD]}>
                <HrDashboard />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.UPDATE}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.UPDATE]}>
                <UpdatePage />
              </ScreenGuard>
            }
          />
          <Route path={ROUTES.PROFILE} element={<Profile />} />
          <Route
            path={ROUTES.MEETING_ROOM}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.MEETING_ROOM]}>
                <MeetingRoom />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.REGISTER}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.REGISTER]}>
                <RegisterPage />
              </ScreenGuard>
            }
          />

          {/* 404 fallback */}
          <Route
            path={ROUTES.PRODUCT}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.PRODUCT]}>
                <Product />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.VENDOR_PURCHASE_CONTRACT}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.VENDOR_PURCHASE_CONTRACT]}>
                <PurchaseContract />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.VENDOR_PURCHASE_CONTRACT_REPORTS}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.VENDOR_PURCHASE_CONTRACT_REPORTS]}>
                <PurchaseContractRecord />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.VENDOR_PURCHASE_CONTRACT_SCHEDULE}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.VENDOR_PURCHASE_CONTRACT_SCHEDULE]}>
                <PurchaseContractSchedule />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.VENDOR_PURCHASE_CONTRACT_SCHEDULE_REPORTS}
            element={
              <ScreenGuard
                screenId={ROUTE_SCREEN_ID_MAP[ROUTES.VENDOR_PURCHASE_CONTRACT_SCHEDULE_REPORTS]}
              >
                <PurchaseContractScheduleReport />
              </ScreenGuard>
            }
          />

          <Route
            path={ROUTES.VENDOR_PURCHASE_CONTRACT_SCHEDULE_EDIT}
            element={
              <ScreenGuard
                screenId={ROUTE_SCREEN_ID_MAP[ROUTES.VENDOR_PURCHASE_CONTRACT_SCHEDULE_EDIT]}
              >
                <PurchaseContractScheduleEdit />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CLIENT_INVOICES}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CLIENT_INVOICES]}>
                <CenterFilterProvider>
                  <ClientInvoices />
                </CenterFilterProvider>
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.MEETING_ROOM_CREDITS}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.MEETING_ROOM_CREDITS]}>
                <MeetingRoomCredits />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CONTRACT_INVOICES}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CONTRACT_INVOICES]}>
                <ContractInvoices />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.INVOICE_SCHEDULE_EDIT}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.INVOICE_SCHEDULE_EDIT]}>
                <InvoiceScheduleEdit />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.VENDOR_TYPES}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.VENDOR_TYPES]}>
                <VendorType />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.UNITS}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.UNITS]}>
                <Units />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.USER_ATTENDANCE}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.USER_ATTENDANCE]}>
                <ClientAttendance />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.PROJECT_COSTING}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.PROJECT_COSTING]}>
                <ProjectCosting />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.PROJECT_COSTING_REPORTS}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.PROJECT_COSTING_REPORTS]}>
                <ProjectCostingReport />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.PROJECT_COSTING_EDIT}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.PROJECT_COSTING_EDIT]}>
                <ProjectCostingEdit />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CHECKLIST_CREATE}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CHECKLIST_CREATE]}>
                <CheckListCreate />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CHECKLIST_REPORTS}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CHECKLIST_REPORTS]}>
                <CheckListReports />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.CHECKLIST_EDIT}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.CHECKLIST_EDIT]}>
                <CheckListEdit />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.WORKFLOW_CREATE}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.WORKFLOW_CREATE]}>
                <WorkflowCreate />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.WORKFLOW_REPORTS}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.WORKFLOW_REPORTS]}>
                <WorkflowReport />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.WORKFLOW_EDIT}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.WORKFLOW_EDIT]}>
                <WorkflowEdit />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.LEASE_FINANCE_INSTITUTION}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.LEASE_FINANCE_INSTITUTION]}>
                <LeaseFinanceInstitution />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.VISITOR_MANAGEMENT}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.VISITOR_MANAGEMENT]}>
                <VisitorManagement />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.VISITOR_MANAGEMENT_REPORT}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.VISITOR_MANAGEMENT_REPORT]}>
                <VisitorManagementReport />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.VISITOR_MANAGEMENT_EDIT}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.VISITOR_MANAGEMENT_EDIT]}>
                <VisitorManagementEdit />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.WATCHMAN_REGISTER}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.WATCHMAN_REGISTER]}>
                <WatchmanRegister />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.AMENDMENT_CREATE}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.AMENDMENT_CREATE]}>
                <AmendmentCreate />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.AMENDMENT_REPORT}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.AMENDMENT_REPORT]}>
                <AmendmentReport />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.AMENDMENT_EDIT}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.AMENDMENT_EDIT]}>
                <AmendmentEdit />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.AMENDMENT_NEW}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.AMENDMENT_NEW]}>
                <AmendmentDetailPage />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.AMENDMENT_DETAILS}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.AMENDMENT_DETAILS]}>
                <AmendmentDetailPage />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.ADDITIONAL_SERVICES_CREATE}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.ADDITIONAL_SERVICES_CREATE]}>
                <AdditionalServicesCreate />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.ADDITIONAL_SERVICES_REPORT}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.ADDITIONAL_SERVICES_REPORT]}>
                <AdditionalServicesReport />
              </ScreenGuard>
            }
          />
          <Route
            path={ROUTES.ADDITIONAL_SERVICES_EDIT}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.ADDITIONAL_SERVICES_EDIT]}>
                <AdditionalServicesEdit />
              </ScreenGuard>
            }
          />

          <Route
            path={ROUTES.WALK_IN}
            element={
              <ScreenGuard screenId={ROUTE_SCREEN_ID_MAP[ROUTES.WALK_IN]}>
                <WalkInPage />
              </ScreenGuard>
            }
          />

          <Route path="/not-found" element={<NotFoundPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  )
}

export default AppRoutes
